import { ImageAspectRatio } from 'domain/constants/imageAspectRatio';
import { Dimension } from 'domain/constants/dimension';

import { CTA } from './cta';
// okay not exactly primitives, but some core types shared between
// all ribbons...
export type SafeColorway = 'LIGHT' | 'NEUTRAL' | 'DARK';
export type UnsafeColorway = SafeColorway | 'PRIMARY' | 'HIGHLIGHT';
export type HBaseline = 1 | 2 | 3 | 4 | 5 | 6;
export type VisibilitySet = Array<[string, string]>;
export type ResponsiveSet<T> = [T, T, T];
export type ButtonKind = 'PRIMARY' | 'SECONDARY';
export type ShortcodeMarkup = string;
export enum Alignment {
  'STARTING' = 'STARTING',
  'CENTER' = 'CENTER',
}
export type Image = {
  url: string;
  focus: 'center center' | 'left center';
};
export type Link = {
  label: string;
  glyph?: string;
  behavior: CTA;
};

export type ImageWithAspectRatios = {
  url?: string;
  preserveDimension?: Dimension | string;
  imageAspectRatio?: ImageAspectRatio;
  focus?: string;
};

export type ImagesWithAspectRatios = ResponsiveSet<ImageWithAspectRatios>;
